import { render, staticRenderFns } from "./round.vue?vue&type=template&id=2b9e6b64&scoped=true&"
import script from "./round.vue?vue&type=script&lang=js&"
export * from "./round.vue?vue&type=script&lang=js&"
import style0 from "./round.vue?vue&type=style&index=0&id=2b9e6b64&scoped=true&lang=css&"
import style1 from "./round.vue?vue&type=style&index=1&id=2b9e6b64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e6b64",
  null
  
)

export default component.exports